import type { CarouselInformativeItemStyleProps } from '../carousel-informative'

export * from './constants'

export const getClassNameByContentConfiguration = (
  baseClassName: string,
  configuration?: {
    alignContentHorizontally: string
  }
) => {
  const className = `${baseClassName} ${baseClassName}__content--${
    configuration?.alignContentHorizontally ?? 'horizontal-align-center'
  }`

  return className
}

// export const getCustomStylesText = (
//   styles?: CarouselInformativeItemTextStyleProps
// ) => {
//   return {
//     ...(styles?.color ? { color: styles?.color } : ''),
//     ...(styles?.textJustify ? { textAlign: styles?.textJustify } : ''),
//   }
// }

// export const getCustomStylesBadge = (styles?: {
//   color?: string
//   backgroundColor?: string
// }) => {
//   return {
//     ...(styles?.color ? { color: styles?.color } : ''),
//     ...(styles?.backgroundColor
//       ? { backgroundColor: styles?.backgroundColor }
//       : ''),
//   }
// }

// export const getCustomStylesPromoDates = (styles?: {
//   color?: string
//   backgroundColor?: string
// }) => {
//   return {
//     ...(styles?.color ? { color: styles?.color } : ''),
//     ...(styles?.backgroundColor
//       ? { backgroundColor: styles?.backgroundColor }
//       : ''),
//   }
// }

export const getCustomStyles = (styles?: CarouselInformativeItemStyleProps) => {
  let styleObject = {}

  for (const prop in styles) {
    if (styles[prop]) {
      styleObject = { ...styleObject, [prop]: styles[prop] }
    }
  }

  return styleObject
}

// export const getStylesBySlide = ({
//   slide,
//   classSlide,
// }: {
//   slide: CarouselInformativeSlideProps
//   classSlide: string
// }) => {
//   // const maxHeight = configurationByDevice?.maxHeightCarousel

//   // if don`t have image, add class no-image-desktop or no-image-mobile
//   const classNoImageByDevice = slide?.background?.src
//     ? ''
//     : `${classSlide}-no-image`

//   const customStylesSlide = {
//     ...(classNoImageByDevice && {
//       // ...(maxHeight ? { height: maxHeight } : ''),
//       ...(slide?.background?.backgroundColor
//         ? { backgroundColor: slide?.background?.backgroundColor }
//         : ''),
//     }),
//   }

//   return {
//     classNoImageByDevice,
//     customStylesSlide,
//   }
// }
